var map = {
	"./activedirectory.svg": 1973,
	"./adfs.svg": 1974,
	"./azuread.svg": 1975,
	"./custom.svg": 962,
	"./email.svg": 617,
	"./freeipa.svg": 1976,
	"./github.svg": 1977,
	"./googleoauth.svg": 1978,
	"./grafana.svg": 1577,
	"./jaeger.svg": 1578,
	"./keycloak.svg": 1979,
	"./kiali.svg": 1579,
	"./linux.svg": 1980,
	"./longhorn.svg": 1580,
	"./neuvector.svg": 1581,
	"./okta.svg": 1981,
	"./openldap.svg": 1982,
	"./pagerduty.svg": 960,
	"./ping.svg": 1983,
	"./prometheus.svg": 1582,
	"./shibboleth.svg": 1984,
	"./slack.svg": 959,
	"./webhook.svg": 961,
	"./windows.svg": 1985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;